"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locateSyntax = void 0;
function locatePath(path) {
    const firstItem = path.items.at(0);
    const lastItem = path.items.at(-1);
    if (!firstItem || !lastItem) {
        return [0, 0];
    }
    return [locatePathItem(firstItem)[0], locatePathItem(lastItem)[1]];
}
function locatePathItem(item) {
    if (item.type === "predicate") {
        return [item.lbracket.offset || 0, (item.rbracket.offset || 0) + 1];
    }
    return [item.offset || 0, (item.offset || 0) + item.text.length];
}
function locateFunctionCall(call) {
    const firstItem = call.path.items.at(0);
    if (!firstItem) {
        return [0, 0];
    }
    return [locatePathItem(firstItem)[0], (call.rparen.offset || 0) + 1];
}
function locateSet(set) {
    return [set.lbracket.offset || 0, (set.rbracket.offset || 0) + 1];
}
function locateUnary(exp) {
    return [exp.token.offset || 0, locateSyntax(exp.operand)[1]];
}
function locateOperator(exp) {
    return [locateSyntax(exp.left)[0], locateSyntax(exp.right)[1]];
}
function locateTernary(exp) {
    return [locateSyntax(exp.conditional)[0], locateSyntax(exp.falsy)[1]];
}
function locateSyntax(exp) {
    switch (exp.type) {
        case "string":
            return [exp.offset || 0, (exp.offset || 0) + exp.text.length];
        case "number":
            return [exp.offset || 0, (exp.offset || 0) + exp.text.length];
        case "boolean":
            return [
                exp.token.offset || 0,
                (exp.token.offset || 0) + exp.token.text.length,
            ];
        case "path":
            return locatePath(exp);
        case "unary":
            return locateUnary(exp);
        case "operator":
        case "comparison":
        case "conjunction":
        case "disjunction":
            return locateOperator(exp);
        case "ternary":
            return locateTernary(exp);
        case "call":
            return locateFunctionCall(exp);
        case "map":
            return locateSet(exp);
        case "array":
            return locateSet(exp);
        default:
            return [0, 0];
    }
}
exports.locateSyntax = locateSyntax;
//# sourceMappingURL=index.js.map